// Supported translation languages for email tool
// Used by EmailToolTab and SupervisorTab for translation features

export const TRANSLATION_LANGUAGES = [
  { code: 'es', name: 'Español',           native: 'Español',    flag: '🇪🇸' },
  { code: 'en', name: 'English',           native: 'English',    flag: '🇬🇧' },
  { code: 'fr', name: 'Francés',           native: 'Français',   flag: '🇫🇷' },
  { code: 'de', name: 'Alemán',            native: 'Deutsch',    flag: '🇩🇪' },
  { code: 'it', name: 'Italiano',          native: 'Italiano',   flag: '🇮🇹' },
  { code: 'pt', name: 'Portugués',         native: 'Português',  flag: '🇵🇹' },
  { code: 'ca', name: 'Catalán',           native: 'Català',     flag: '🏴󠁥󠁳󠁣󠁴󠁿' },
  { code: 'nl', name: 'Holandés',          native: 'Nederlands', flag: '🇳🇱' },
  { code: 'pl', name: 'Polaco',            native: 'Polski',     flag: '🇵🇱' },
  { code: 'ru', name: 'Ruso',              native: 'Русский',    flag: '🇷🇺' },
  { code: 'zh', name: 'Chino simplificado', native: '中文 (简体)',  flag: '🇨🇳' },
  { code: 'ja', name: 'Japonés',           native: '日本語',       flag: '🇯🇵' },
  { code: 'ar', name: 'Árabe',             native: 'العربية',    flag: '🇸🇦' },
];

export const getLanguageByCode = (code) =>
  TRANSLATION_LANGUAGES.find(l => l.code === code) || TRANSLATION_LANGUAGES[0];
